import React from "react";
import { Maximize2 } from "lucide-react";
import { cn } from "../utils";
import { typography } from "../tokens";
import { Panel } from "../panel";
import { HeaderIconButton } from "../shell/app-header";
import { PageSection } from "./layout";

export function ChartExpandButton({ onClick, title = "Expand", className }) {
  return (
    <HeaderIconButton
      onClick={onClick}
      title={title}
      aria-label={title}
      className={cn("text-gray-400 hover:text-gray-700", className)}
    >
      <Maximize2 className="w-4 h-4" />
    </HeaderIconButton>
  );
}

export function ChartCardHeader({ title, action, className }) {
  return (
    <div className={cn("flex items-center justify-between gap-2 px-4 py-3 border-b border-gray-100 flex-shrink-0", className)}>
      <h3 className="text-gray-900 truncate m-0 min-w-0" style={typography.section}>
        {title}
      </h3>
      {action}
    </div>
  );
}

export function ChartCardBody({ children, className, padded }) {
  return (
    <div className={cn("flex-1 min-h-0", padded && "p-2", className)}>
      {children}
    </div>
  );
}

export function ChartCard({
  title,
  action,
  children,
  className,
  bodyClassName,
  bodyPadded,
  ...props
}) {
  return (
    <Panel rounded="sm" shadow padding="none" className={cn("flex flex-col min-h-0 h-full", className)} {...props}>
      {title && <ChartCardHeader title={title} action={action} />}
      <ChartCardBody className={bodyClassName} padded={bodyPadded}>
        {children}
      </ChartCardBody>
    </Panel>
  );
}

export function ChartCardGrid({ children, cols = "grid-cols-1 md:grid-cols-2 xl:grid-cols-3", className }) {
  return <div className={cn("grid gap-4 auto-rows-fr", cols, className)}>{children}</div>;
}

export function DashboardPage({ kpi, children, className }) {
  return (
    <PageSection className={cn("pb-4", className)}>
      {kpi}
      {children}
    </PageSection>
  );
}
